import React from "react";

export default function ItinerarySection() {
  const events = {
    tuesday: [
      { time: "18:30", title: "Geet Gawai" },
      { time: "19:00", title: "Dinner Time" },
      { time: "22:30", title: "End of Night" },
    ],
    wednesday: [
      { time: "08:00", title: "Haldi Taline" },
      { time: "10:00", title: "Haldi Atish" },
      { time: "12:00", title: "Lunch Time" },
      { time: "14:30", title: "Wedding Ceremony" },
      { time: "18:00", title: "Dinner Time" },
      { time: "22:30", title: "End of Night" },
    ],
    thursday: [
      { time: "12:00", title: "Chawtari" },
      { time: "12:30", title: "Reception" },
      { time: "16:00", title: "Cake Cutting" },
      { time: "22:30", title: "End of Night" },
    ],
  };

  return (
    <section
      id="itinerary"
      className="relative min-h-screen py-12 px-6"
      style={{
        backgroundImage: "url('/Images/Itinerary/Wedding_Itinerary_background.png')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundColor: "#FDFBF5",
      }}
    >
      <div className="max-w-6xl mx-auto">
        <div className="w-full md:w-1/2 mx-auto flex flex-col space-y-8">

          <div className="self-end w-fit max-w-full">
            <h1 className="font-garamond text-4xl font-bold text-gray-800 mb-12 mt-12 text-right">
              Wedding Itinerary
            </h1>
          </div>

          <div className="self-start w-fit max-w-full" style={{margin: "0"}}>
            <h2 className="font-garamond text-3xl text-gray-800 mb-2 font-medium">Tuesday</h2>
            <ul className="space-y-1 font-garamond text-lg text-gray-700">
              {events.tuesday.map((event, index) => (
                <li key={index} className="flex gap-4">
                  <span className="font-semibold w-24">{event.time}</span>
                  <span>{event.title}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="self-end w-fit max-w-full" style={{margin: "16px 0px"}}>
            <h2 className="font-garamond text-3xl text-gray-800 mb-2 font-medium">Wednesday</h2>
            <ul className="space-y-1 font-garamond text-lg text-gray-700">
              {events.wednesday.map((event, index) => (
                <li key={index} className="flex gap-4">
                  <span className="font-semibold w-24">{event.time}</span>
                  <span>{event.title}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="self-start w-fit max-w-full" style={{margin: "0"}}>
            <h2 className="font-garamond text-3xl text-gray-800 mb-2 font-medium">Thursday</h2>
            <ul className="space-y-1 font-garamond text-lg text-gray-700">
              {events.thursday.map((event, index) => (
                <li key={index} className="flex gap-4">
                  <span className="font-semibold w-24">{event.time}</span>
                  <span>{event.title}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="self-end w-fit max-w-full">
            <p className="font-garamond text-lg italic font-semibold text-gray-700">
              Times may be subject to change.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
